/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'

import { ChargeType, ServiceType } from '../../../../../presentation/enums/stablishment-tables'
import { formatDataForm, removeProperties } from '../../../../../presentation/helpers/helper-object'
import { priceToNumber } from '../../../../../presentation/helpers/helper-price'
import { removeSpaces, removeSpecialChars, stringToBoolean } from '../../../../../presentation/helpers/helper-string'
import TableConfigurationEditor from '../../../../../presentation/pages/dashboard/tables/configurations/editor'
import { theme } from '../../../../../presentation/styles/theme'
import { makeTableOption } from '../../../../usecases/table-options/load-table-option-factory'

const MakeTableConfigurationEditor = () => {
  const { setHeader } = usePage()
  const { setType, setText, setIsShowing } = useSnackbar()
  const { me } = useMe()
  const { onSetLoading } = useLoading()
  const [errorMessage] = useState('')

  const dataForm = [
    {
      items: [
        {
          name: 'hasServiceCharge',
          component: 'InputRadio',
          required: true,
          value: 'false',
          title: 'Deseja inserir taxa de serviço para todas mesas?',
          label: 'Deseja inserir taxa de serviço para todas mesas?',
          options: [{ label: 'Sim', value: 'true' }, { label: 'Não', value: 'false' }],
        },
        {
          name: 'serviceType',
          component: 'InputRadio',
          required: true,
          value: '',
          title: 'Qual tipo de serviço?',
          label: 'Qual tipo de serviço?',
          options: [
            { label: 'Atendimento', value: ServiceType.ATTENDANCE },
            { label: 'Couver', value: ServiceType.COVER },
          ],
          dependencies: [{ name: 'hasServiceCharge', value: 'true' }],
        },
        {
          name: 'chargeType',
          component: 'InputRadio',
          required: true,
          value: '',
          title: 'A taxa será fixa ou percentual?',
          label: 'A taxa será fixa ou percentual?',
          dependencies: [{ name: 'serviceType', value: String(ServiceType.ATTENDANCE) }],
          options: [
            {
              label: 'Percentual',
              value: ChargeType.PERCENTAGE,
            },
            {
              label: 'Fixa',
              value: ChargeType.FIXED,
            },
          ],
        },
        {
          component: 'InputMask',
          name: 'chargeAmountFixed',
          required: true,
          dependencies: [
            { name: 'chargeType', value: String(ChargeType.FIXED) },
            { name: 'serviceType', value: String(ServiceType.COVER) },
          ],
          label: 'Digite o valor (R$)',
          title: 'Digite o valor (R$)',
          mask: 'CURRENCY',
          type: 'text',
          value: '',
          placeholder: 'Digite aqui',
          styleContainer: { width: '25%' },
        },
        {
          component: 'Input',
          name: 'chargeAmountPercentage',
          required: true,
          dependencies: [
            { name: 'chargeType', value: String(ChargeType.PERCENTAGE) },
          ],
          label: 'Digite o percentual (%)',
          title: 'Digite o percentual (%)',
          type: 'number',
          value: '',
          placeholder: 'Digite aqui',
          styleContainer: { width: '25%' },
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar',
          submittingText: 'Salvando...',
          style: { background: theme.colors.blue, width: '35%', marginTop: '45px' },
        },
      ],
    },
  ]

  useEffect(() => {
    (async () => {
      onSetLoading(true)
      setHeader({
        title: 'Configurações',
        goTo: null,
      })
      onSetLoading(false)
    })()
  }, [setHeader, me])

  const onSubmit = async (values: any) => {
    let itemToSubmit = { ...values }

    const numberAdapter = (value: string) => (
      value || value !== ''
        ? Number(removeSpecialChars(removeSpaces(String(value))))
        : null
    )

    const itemGroup = [
      { name: 'hasServiceCharge', adapter: stringToBoolean },
      { name: 'serviceType', adapter: numberAdapter },
      { name: 'chargeType', adapter: numberAdapter },
      { name: 'chargeAmountFixed', adapter: priceToNumber },
      { name: 'chargeAmountPercentage', adapter: numberAdapter },
    ]
    itemToSubmit = formatDataForm(itemToSubmit, itemGroup)

    const chargeAmount = itemToSubmit.chargeType === ChargeType.PERCENTAGE
      ? itemToSubmit.chargeAmountPercentage && Number(itemToSubmit.chargeAmountPercentage)
      : itemToSubmit.chargeAmountFixed && itemToSubmit.chargeAmountFixed

    itemToSubmit.chargeAmount = chargeAmount

    const itemsToDelete = ['button', 'undefined', 'chargeAmountPercentage', 'chargeAmountFixed']
    if (itemToSubmit.chargeAmount === '') itemsToDelete.push('chargeAmount')
    itemToSubmit = removeProperties(itemToSubmit, itemsToDelete)

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      await makeTableOption(stablishmentId).post(itemToSubmit)

      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <TableConfigurationEditor
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
    />
  )
}

export default MakeTableConfigurationEditor
